export const STATUS_KANBAN_PENDENTE = 'pendente';
export const STATUS_KANBAN_EM_ANDAMENTO = 'em_andamento';
export const STATUS_KANBAN_CONCLUIDA = 'concluida';

const STATUS_KANBAN_LABELS: Record<string, string> = {
    [STATUS_KANBAN_PENDENTE]: 'Pendente',
    [STATUS_KANBAN_EM_ANDAMENTO]: 'Em Andamento',
    [STATUS_KANBAN_CONCLUIDA]: 'Concluída',
};

export const getStatusLabelStatusKanban = (status: string): string =>
    STATUS_KANBAN_LABELS[status] ?? status;

export const RESULTADO_RESOLVIDA = 'resolvida';
export const RESULTADO_ACEITA = 'aceita';
export const RESULTADO_RECUSADA = 'recusada';

const RESULTADO_PENDENCIA_LABELS: Record<string, string> = {
    [RESULTADO_RESOLVIDA]: 'Resolvida',
    [RESULTADO_ACEITA]: 'Aceita',
    [RESULTADO_RECUSADA]: 'Recusada',
};

export const getResultadoLabelPendencia = (resultado: string | null | undefined): string => {
    if (resultado == null || resultado === '') return '—';
    return RESULTADO_PENDENCIA_LABELS[resultado] ?? resultado;
};
